import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    position: 'relative',
    display: 'inline-block',
  },
  error: {
    position: 'absolute',
    top: '100%',
    left: 0,
    color: 'rgb(244, 67, 54)',
  },
  edit: {
    marginTop: theme.spacing(-2),
    marginLeft: theme.spacing(-1),
    marginBottom: theme.spacing(-2),
  },
}))
